export const getBreakpointAsNumber = (screenSize: string): number => {
  const numbersInSize = screenSize.match(/\d+/);
  if (!numbersInSize) {
    return 0;
  }
  return parseInt(numbersInSize[0], 10);
};
